import {combineReducers} from '@reduxjs/toolkit';

import {serverTimeZoneSlice} from './serverTimeZone.slice';

export const configReducer = combineReducers({
    serverTimeZone: serverTimeZoneSlice.reducer
});
